import React, { useState, useEffect } from 'react';
// library
import { useAlert } from 'react-alert';
// style
import styles from './options.module.css';
// component
import Btn from '../button/btn';
import Svg from '../icons/svg';
// query
import { useLockToggleDirectMessage } from '../../../query';
import { useDeleteDirectMessage } from '../../../query';

export default function Options({ adminLoggedIn, clientIsOwner, messageId, memberId, locked, forLastMessage }) {
  const alert = useAlert();

  const [toggle, setToggle] = useState(false);

  const [toggleLock, toggleLockQuery] = useLockToggleDirectMessage();
  const [deleteMessage, deleteMessageQuery] = useDeleteDirectMessage();

  const handleToggleMenu = () => {
    setToggle((prevState) => !prevState);
  };

  const handleDelete = () => {
    if (!deleteMessageQuery.isLoading) {
      deleteMessage(
        {
          id: messageId,
          memberId,
        },
        {
          onSuccess: (response) => {
            const { status, message } = response.data;

            if (status === 'warning') {
              alert.error(message);
            }
          },
        },
      );
    }
  };

  const handleLockToggle = () => {
    if (!toggleLockQuery.isLoading) {
      toggleLock({
        id: messageId,
        memberId,
      });
    }
  };

  useEffect(() => {}, [toggleLockQuery.isLoading]);

  if (!(adminLoggedIn || clientIsOwner)) {
    return null;
  }

  return (
    <>
      <div className={[styles.options, clientIsOwner ? styles.right : styles.left].join(' ')}>
        <div className={styles.globalCloser} onClick={handleToggleMenu} style={{ display: toggle ? 'flex' : 'none' }} />

        <div className={styles.toggle} onClick={handleToggleMenu}>
          <span />
          <span />
          <span />
        </div>

        <div
          className={[styles.list, forLastMessage ? styles.listLastMessage : ''].join(' ')}
          style={{ display: toggle ? 'flex' : 'none' }}
        >
          <Btn
            type="button"
            loading={deleteMessageQuery.isLoading}
            disabled={deleteMessageQuery.isLoading}
            className={`${styles.item} btn text-danger`}
            loadingFill={'#555555'}
            onClick={handleDelete}
          >
            <Svg name={'trash'} width={14} />
          </Btn>
          {adminLoggedIn && (
            <Btn
              type="button"
              loading={toggleLockQuery.isLoading}
              disabled={toggleLockQuery.isLoading}
              className={`${styles.item} btn text-primary`}
              loadingFill={'#555555'}
              onClick={handleLockToggle}
            >
              <Svg name={parseInt(locked, 10) ? 'lockKeyhole' : 'lockOpen'} width={14} />
            </Btn>
          )}

          {/* <div className={styles.closeList} onClick={handleToggleMenu}>
                        <Svg name={'arrowLeft'} width={14} fill={'#464748'} label={'Back'} />
                    </div> */}
        </div>
      </div>
    </>
  );
}
